<template>
  <div>
    <div @click="projectClicked" :class="{ metsub: (project.sub && project.sub.length > 0), 'proj_item': true }" :style="inspr">
      {{ project.omschr }}
    </div>
    <div v-if="toonSubs">
      <project v-for="p in project.sub" :key="p.id" :project="p" :depth="depth + 1" @gekozen="subGekozen"></project>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'project',
    props: ['project', 'depth'],
    data() {
      return { toonSubs: false }
    },
    computed: {
      inspr() {
        return {'padding-left': `${this.depth * 20}px`}
      }
    },
    methods: {
      projectClicked() {
        if (this.project.sub && this.project.sub.length > 0) {
          this.toonSubs = !this.toonSubs
        }
        else {
          this.$emit('gekozen', this.project)
        }
      },
      subGekozen(p) {
        this.$emit('gekozen', p)
      }
    }
  }
</script>

<style lang="stylus">
  .proj_item
    font-size: 16px
    padding: 6px 0
  .metsub
    color: black
  .metsub:after {
      content: " »"
  }
</style>
